import React from 'react';
import { useLocation } from 'react-router';
import useMfeModule from '|/helpers/use-mfe-module';

declare global {
  interface Window {
    CarvanaChatUiModule: {
      default: any;
    };
  }
}

function mfeCacheBuster() {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;
  return `${date.getDate()}${date.getHours()}${nearestQuarterHour}`;
}

const ChatUi = () => {
  const isReady = useMfeModule(
    `${
      process.env.CHAT_BASE_URL
    }/build/assets-manifest.json?v=${mfeCacheBuster()}`,
    'main.js',
    'CarvanaChatUiModule'
  );

  const { pathname } = useLocation();

  if (
    !isReady ||
    pathname.startsWith('/steps/order-placed') ||
    pathname.startsWith('/vehicle/')
  )
    return null;
  const ChatMfe = window.CarvanaChatUiModule.default;
  return <ChatMfe />;
};

export default ChatUi;
